/**
 * Utility to load all nightingale components
 */
export async function loadNightingaleComponents(): Promise<void> {
  try {
    await Promise.all([
      import('@nightingale-elements/nightingale-msa'),
      import('@nightingale-elements/nightingale-manager'),
      import('@nightingale-elements/nightingale-navigation'),
      import('@nightingale-elements/nightingale-sequence'),
      import('@nightingale-elements/nightingale-links')
    ]);
  } catch (error) {
    console.error('Failed to load nightingale components:', error);
    throw error;
  }
}